type MemberDisplayLabelInput = {
  displayName?: string | null
  memberId?: string | null
  userId?: string | null
}

export function memberDisplayLabel(input: MemberDisplayLabelInput): string {
  const normalizedDisplayName = input.displayName?.trim()
  if (normalizedDisplayName) {
    return normalizedDisplayName
  }

  return input.memberId ?? input.userId ?? "Unknown member"
}
